import React from 'react';
import { ExternalLink } from 'lucide-react';
import BackendTemplateConfig from '@/configs/BackendTemplateConfig';

const Analytics = () => {
  const dashboardUrl = "https://umami.horoboro.com/share/c3NgHcXL0wfL3Kz3/xn--suurizngli-feb.ch";
  
  return (
    <div className={`${BackendTemplateConfig.container.minHeight} ${BackendTemplateConfig.container.backgroundGradient} ${BackendTemplateConfig.layout.flexCenter}`}>
      <div className={`${BackendTemplateConfig.card.base} ${BackendTemplateConfig.container.maxWidth} ${BackendTemplateConfig.card.paddingLarge} max-w-md`}>
        <h2 className={`${BackendTemplateConfig.typography.pageTitle} mb-4 text-center`}>
          Umami Analytics Dashboard
        </h2>
        <p className={`${BackendTemplateConfig.typography.body} mb-6 text-center`}>
          Due to security restrictions, the dashboard cannot be embedded directly. 
          Click below to open it in a new tab.
        </p>
        <div className={`${BackendTemplateConfig.layout.flexCenter} mb-6`}>
          <a
            href={dashboardUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`${BackendTemplateConfig.buttons.primary} ${BackendTemplateConfig.layout.flex} ${BackendTemplateConfig.layout.flexGap.medium} ${BackendTemplateConfig.animations.transition.colors}`}
          >
            Open Dashboard
            <ExternalLink className={BackendTemplateConfig.icons.medium} />
          </a>
        </div>
        <div className={`${BackendTemplateConfig.colors.warning[50]} ${BackendTemplateConfig.borders.default} border-amber-200 ${BackendTemplateConfig.borderRadius.md} ${BackendTemplateConfig.card.padding}`}>
          <p className={`${BackendTemplateConfig.typography.small} ${BackendTemplateConfig.colors.warning.text}`}>
            <strong className={BackendTemplateConfig.typography.heading}>Note:</strong> The iframe embedding is blocked by Content Security Policy (CSP) frame-ancestors directive set by the Umami server.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Analytics;